import { render, staticRenderFns } from "./productline.vue?vue&type=template&id=bd57e94c&scoped=true&"
import script from "./productline.vue?vue&type=script&lang=js&"
export * from "./productline.vue?vue&type=script&lang=js&"
import style0 from "./productline.vue?vue&type=style&index=0&id=bd57e94c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd57e94c",
  null
  
)

export default component.exports